import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './ChatBotProductRecommendations.css';

const ChatBotProductRecommendations = ({products, onAddToCart}) => {
    if (!products || products.length === 0) return null;

    return (
        <div className="sealab-livechat__product-recommendations">
            <h6 className="sealab-livechat__product-recommendations-title">
                Recommended Products
            </h6>
            <div className="sealab-livechat__product-grid">
                {products.map((product, index) => (
                    <div key={index} className="sealab-livechat__product-card">
                        <div className="sealab-livechat__product-header">
                            <h6 className="sealab-livechat__product-id">
                                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                    {`**${product.serialNumber}**`}
                                </ReactMarkdown>
                            </h6>
                        </div>
                        <div className="sealab-livechat__product-body">
                            <p className="sealab-livechat__product-description">{product.description}</p>
                            <div className="sealab-livechat__product-dimensions">
                                <span><strong>W:</strong> {product.width}"</span>
                                <span><strong>H:</strong> {product.height}"</span>
                                <span><strong>D:</strong> {product.depth}"</span>
                            </div>
                        </div>
                        <button
                            className="sealab-livechat__add-to-cart-btn"
                            onClick={() => onAddToCart(product)}
                        >
                            Add to Cart
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ChatBotProductRecommendations;
